import { useMemo, useCallback } from 'react'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import { getLoginState, getToken, getPermissions } from './selectors'
import { login, logout, init } from './actions'
import { loadTokenAndUserFromStorage } from './reducer'

export const useLogin = () => {
  const state = useSelector(getLoginState, shallowEqual)

  const dispatch = useDispatch()

  const actions = useMemo(
    () => ({
      init: () => {
        dispatch(init(loadTokenAndUserFromStorage()))
      },
      login: (user, password) => dispatch(login(user, password)),
      logout: () => dispatch(logout()),
    }),
    [dispatch]
  )

  return [state, actions]
}

export const useLogout = () => {
  const dispatch = useDispatch()
  const action = useCallback(() => dispatch(logout()), [dispatch])
  return action
}

export const useToken = () => {
  const state = useSelector(getToken)

  return state
}

export const usePermissions = (requestedPermissions) => {
  const permissions = useSelector(getPermissions)
  if (permissions === null) return requestedPermissions.map((p) => false) // permissions not fetched yet
  const result = requestedPermissions.map((p) => permissions.includes(p))
  return result
}
